/**
 * SectionHeader — uppercase section label for grouped lists.
 * Design source: prototype.jsx:359-368.
 * Atom purity: imports only react + tokens.
 */
import { CSSProperties, ReactNode } from 'react';
import { S, T } from '../../styles/tokens';

export interface SectionHeaderProps {
  children: ReactNode;
  /** Dark-surface mode — white-ish text for use on dark backgrounds. */
  dark?: boolean;
  style?: CSSProperties;
}

export function SectionHeader({ children, dark = false, style }: SectionHeaderProps) {
  const base: CSSProperties = {
    font: T.footnote,
    textTransform: 'uppercase',
    // prototype:366 uses rgba(255,255,255,0.7) for dark (slightly higher opacity than S.secondaryLabelDark)
    color: dark ? 'rgba(255,255,255,0.7)' : S.secondaryLabel,
    // prototype:364 — 36px horizontal to indent past card edges
    padding: '12px 36px 6px',
    letterSpacing: -0.08,
    boxSizing: 'border-box',
    ...style,
  };

  return <div style={base}>{children}</div>;
}
